// system/* page translations
const system = {
  management: {
    tabs: {
      general: 'Chung',
      monitoring: 'Giám sát',
      alarm: 'Thông báo',
      security: 'Bảo mật',
      dataCollection: 'Thu thập dữ liệu',
      log: 'Nhật ký hệ thống',
      ip: 'Quản lý IP',
    },
    common: {
      save: 'Lưu cài đặt',
      saving: 'Đang lưu...',
      loading: 'Đang tải...',
      refresh: 'Làm mới',
      saveSuccess: 'Đã lưu cài đặt. Đang tải lại trang...',
      saveFailed: 'Không thể lưu cài đặt.',
      defaultSystemName: 'Hệ thống giám sát ép phun tích hợp',
    },
    general: {
      sectionBasic: 'Thông tin cơ bản',
      sectionContact: 'Thông tin liên hệ',
      sectionBranding: 'Thương hiệu',
      labels: {
        systemName: 'Tên hệ thống',
        companyName: 'Tên công ty',
        companyCode: 'Mã công ty',
        schemaName: 'Tên schema',
        businessNumber: 'Mã đăng ký kinh doanh',
        representativeName: 'Người đại diện',
        contactEmail: 'Email',
        contactPhone: 'Điện thoại',
        address: 'Địa chỉ',
        logo: 'Logo',
        favicon: 'Favicon',
      },
      placeholders: {
        contactEmail: 'example@company.com',
        contactPhone: '02-1234-5678',
        address: '123 Teheran-ro, Gangnam-gu, Seoul',
      },
      branding: {
        upload: 'Tải lên',
        change: 'Thay đổi',
        delete: 'Xóa',
        uploading: 'Đang tải lên...',
        logoAlt: 'Xem trước logo',
        faviconAlt: 'Xem trước favicon',
        hint: 'Hỗ trợ: JPG, PNG, GIF, SVG, ICO (tối đa 5MB)',
        logoUploadComplete: 'Đã tải logo (áp dụng khi lưu)',
        faviconUploadComplete: 'Đã tải favicon (áp dụng khi lưu)',
        uploadFailed: 'Tải lên thất bại',
        fileUploadFailed: 'Tải tệp thất bại.',
      },
    },
    monitoring: {
      sectionDashboard: 'Cài đặt bảng điều khiển',
      labels: {
        refreshInterval: 'Khoảng thời gian làm mới tự động',
        timezone: 'Múi giờ',
      },
      refreshOptions: {
        onComplete: 'Khi hoàn tất thu thập dữ liệu',
        sec10: '10 giây',
        sec30: '30 giây',
        min1: '1 phút',
        min5: '5 phút',
        min10: '10 phút',
        disabled: 'Tắt',
      },
      timezones: {
        seoul: 'Giờ chuẩn Hàn Quốc (KST, UTC+9)',
        hochiminh: 'Giờ chuẩn Việt Nam (ICT, UTC+7)',
        utc: 'Giờ phối hợp quốc tế (UTC)',
        tokyo: 'Giờ chuẩn Nhật Bản (JST, UTC+9)',
        newyork: 'Giờ miền Đông Hoa Kỳ (EST/EDT)',
        london: 'Giờ chuẩn Anh (GMT/BST)',
      },
    },
    alarm: {
      sectionChannels: 'Kênh thông báo',
      sectionSound: 'Âm thanh cảnh báo',
      labels: {
        web: 'Thông báo trên web',
        email: 'Thông báo email',
        sms: 'Thông báo SMS',
        push: 'Thông báo đẩy web',
        sound: 'Âm thanh cảnh báo',
        mute: 'Tắt tiếng',
      },
      hints: {
        web: 'Hiển thị thông báo ở đầu trang web',
        email: 'Gửi thông báo đến email đã đăng ký (sắp ra mắt)',
        sms: 'Gửi tin nhắn đến số điện thoại đã đăng ký (sắp ra mắt)',
        push: 'Gửi thông báo đẩy của trình duyệt (sắp ra mắt)',
        sound: 'Âm thanh phát khi có cảnh báo mới (chỉ lưu trên trình duyệt này)',
        mute: 'Khi bật, âm thanh cảnh báo sẽ không phát',
      },
      preview: 'Nghe thử',
      sounds: {
        single: 'Bíp đơn',
        double: 'Bíp đôi',
        triple: 'Bíp ba',
        chime: 'Chuông',
        siren: 'Còi báo',
      },
      on: 'BẬT',
      off: 'TẮT',
    },
    security: {
      sectionLogin: 'Bảo mật đăng nhập',
      labels: {
        maxAttempts: 'Số lần đăng nhập sai tối đa',
        lockDuration: 'Thời gian khóa tài khoản',
      },
      hints: {
        maxAttempts: 'Tài khoản sẽ bị khóa sau số lần đăng nhập sai đã cấu hình',
        lockDuration: 'Thời gian cho đến khi tự động mở khóa',
      },
      attempts: {
        n3: '3 lần',
        n5: '5 lần',
        n10: '10 lần',
      },
      duration: {
        m5: '5 phút',
        m10: '10 phút',
        m30: '30 phút',
        h1: '1 giờ',
        h24: '24 giờ',
      },
    },
    dataCollection: {
      sectionStatus: 'Trạng thái ETL',
      sectionDb: 'Trạng thái kết nối cơ sở dữ liệu',
      sectionHistory: 'Lịch sử đồng bộ',
      cards: {
        runState: 'Trạng thái thực thi',
        lastRun: 'Lần chạy cuối',
        lastSuccess: 'Thành công gần nhất',
        recordsProcessed: 'Bản ghi đã xử lý',
      },
      runState: {
        running: 'Đang chạy',
        idle: 'Chờ',
      },
      db: {
        rawName: 'Raw DB (MariaDB)',
        monitoringName: 'Monitoring DB (PostgreSQL)',
        connected: 'Đã kết nối',
        disconnected: 'Mất kết nối',
        unknown: 'Không xác định',
      },
      history: {
        col: {
          time: 'Thời gian đồng bộ',
          status: 'Trạng thái',
          records: 'Bản ghi',
          tables: 'Bảng đích',
          note: 'Ghi chú',
        },
        statusSuccess: 'Thành công',
        statusFailed: 'Thất bại',
        empty: 'Không có lịch sử đồng bộ',
      },
      actions: {
        refresh: 'Làm mới',
        manualSync: 'Đồng bộ thủ công',
        running: 'Đang chạy...',
        inProgress: 'Đang đồng bộ',
      },
      messages: {
        syncStarted: 'Đã bắt đầu đồng bộ ETL.',
        syncFailed: 'Bắt đầu đồng bộ ETL thất bại.',
      },
      recordsUnit: '{n}',
    },
    log: {
      sectionHistory: 'Lịch sử đăng nhập/đăng xuất',
      filters: {
        all: 'Tất cả',
        login: 'Đăng nhập',
        logout: 'Đăng xuất',
        loginFailed: 'Đăng nhập thất bại',
      },
      col: {
        time: 'Thời gian',
        type: 'Loại',
        user: 'Người dùng',
        email: 'Email',
        ip: 'Địa chỉ IP',
        note: 'Ghi chú',
      },
      empty: 'Không có lịch sử đăng nhập',
    },
  },
  ip: {
    notReady: {
      title: 'Tính năng máy chủ chưa sẵn sàng',
      body: 'Giới hạn IP truy cập chưa được triển khai trên máy chủ. Màn hình này không thể lưu địa chỉ IP hoặc chặn truy cập.',
      empty: 'Chưa có địa chỉ IP nào',
    },
    controls: {
      addBtn: 'Thêm IP',
    },
    table: {
      ip: 'Địa chỉ IP',
      description: 'Mô tả',
      access: 'Quyền truy cập',
      status: 'Trạng thái',
      lastAccess: 'Truy cập cuối',
      createdAt: 'Ngày đăng ký',
      createdBy: 'Người đăng ký',
      actions: 'Thao tác',
    },
  },
};
export default system;
